import React, { useState } from 'react';
import { MenuItem } from '@mui/material';

import KogModalSideComponent from '@/main/components/modal/ModalSide';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import AccordionQuoteHistory from '@/main/components/shared/accordionQuoteHistory/accordionQuoteHistory';
import { Controls } from '@/main/services/constants/constantsControl';
import { getTranslateByKey, isShowControlByElementId } from '@/main/services/utils';

import * as S from '../styles';
import { useThreeDotsQuoteContext } from '../contex';

interface IThreeDotsQuoteHistoryProps {
  guidScreen: string;
  guidQuote: string;
}
function ThreeDotsQuoteHistory({
  guidQuote,
  guidScreen,
}: IThreeDotsQuoteHistoryProps) {
  const {
    closeThreeDotsQuote
  } = useThreeDotsQuoteContext();
  const [modalHistory, setModalHistory] = useState<boolean>(false);
  const showPrices = isShowControlByElementId(Controls.IdShowPrices);

  function handleClick() {
    setModalHistory(true)
  }
  function closeModal() {
    setModalHistory(false);
    closeThreeDotsQuote();
  }

  return (
    <>
      <MenuItem
        id="id-createOrder-button-history"
        onClick={handleClick}
      >
        {getTranslateByKey('information.history')}
      </MenuItem>
      {modalHistory && (
        <KogModalSideComponent
          open={modalHistory}
          closeModal={() => closeModal()}
          title={getTranslateByKey('information.history')}>
          <S.ContentAccordionQuoteHistory>
            <AccordionQuoteHistory
              guidScreen={guidScreen}
              showPrices={showPrices}
              guidQuote={guidQuote}
            />
          </S.ContentAccordionQuoteHistory>
          <S.FooterButtonHistory>
            <SecondaryButton
              id="id-createOrder-button-back"
              onClick={() => closeModal()}
            >
              {getTranslateByKey('information.back')}
            </SecondaryButton>
          </S.FooterButtonHistory>
        </KogModalSideComponent>
      )}
    </>
  )
}

export { ThreeDotsQuoteHistory };
